import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Button, Input } from '@cian/ui-kit';
import { IconActionClose16, IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './CreateFolderForm.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CreateFolderForm(_ref) {
  var isCreating = _ref.isCreating,
    onCreate = _ref.onCreate,
    onCancel = _ref.onCancel;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    name = _React$useState2[0],
    setName = _React$useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['input'],
      children: /*#__PURE__*/_jsx(Input, {
        disabled: isCreating,
        maxLength: 150,
        value: name,
        onChange: function onChange(e) {
          return setName(e.target.value);
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['button'],
      children: /*#__PURE__*/_jsx(Button, {
        size: "XS",
        loading: isCreating,
        disabled: !name || isCreating,
        fullWidth: true,
        beforeIcon: /*#__PURE__*/_jsx(IconFunctionalSuccess16, {
          color: name ? 'icon-inverted-default' : 'gray20_100'
        }),
        onClick: function onClick() {
          return onCreate(name);
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['button'],
      children: /*#__PURE__*/_jsx(Button, {
        disabled: isCreating,
        size: "XS",
        fullWidth: true,
        theme: "fill_secondary",
        beforeIcon: /*#__PURE__*/_jsx(IconActionClose16, {
          color: "icon-main-default"
        }),
        onClick: onCancel
      })
    })]
  });
}